export default function ErrorPage(){
    return (<>
    <div className="w-full h-screen flex">
        <img src="./assets/50479-sleeping-404.gif" className="w-72 h-72 m-auto"  alt="" />
    </div>
    </>)
}